import { useEffect, useRef, useState } from 'react'

export const useIsScrollingDown = () => {
  const [isScrollingDown, setIsScrollingDown] = useState(false)
  const [lastScrollTop, _setLastScrollTop] = useState(0)

  const lastScrollTopRef = useRef(lastScrollTop)

  const setLastScrollTop = (scrollTop: number) => {
    lastScrollTopRef.current = scrollTop
    _setLastScrollTop(scrollTop)
  }

  useEffect(() => {
    if (!window) return

    const _scrollListener = () => {
      const scrollTop = document.querySelector('html')?.scrollTop || 0

      const scrolledDistance = Math.abs(lastScrollTopRef.current - scrollTop)
      const hasScrolled = scrolledDistance > 100

      if (!hasScrolled) return

      setIsScrollingDown(scrollTop > lastScrollTopRef.current)
      setLastScrollTop(scrollTop <= 0 ? 0 : scrollTop)
    }

    window.addEventListener('scroll', _scrollListener)

    return () => window.removeEventListener('scroll', _scrollListener)
  }, [])

  return isScrollingDown
}
